import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=0fe0ba02&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=0fe0ba02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0ba02",
  null
  
)

export default component.exports